// src/components/CountrySelector.tsx
import React from "react";

const CountrySelector: React.FC<{ countries: { abbr: string, code: string }[], onCountrySelect: (abbr: string) => void }> = ({ countries, onCountrySelect }) => {
  return (
    <div className="country-selector">
      {countries.map((country) => (
        <button key={country.abbr} className="country-btn" onClick={() => onCountrySelect(country.abbr)}>
          {country.code}
        </button>
      ))}
    </div>
  );
};

export default CountrySelector;
